import React, {FC} from 'react';
import styled from 'styled-components';

import {
  SignaturesTableMultiSelectDeleteAction,
  SignaturesTableMultiSelectDeleteActionProps,
} from './actions/signaturesTableMultiSelectDeleteAction';

/*
 * Style.
 */

const StyledSignaturesTableActionsContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
`;

/*
 * Component.
 */

export const SignaturesTableActions: FC<SignaturesTableMultiSelectDeleteActionProps> = ({
  signatureIds,
  onSuccessfulDelete,
}) => (
  <StyledSignaturesTableActionsContainerDiv>
    <SignaturesTableMultiSelectDeleteAction
      signatureIds={signatureIds}
      onSuccessfulDelete={onSuccessfulDelete}
    />
  </StyledSignaturesTableActionsContainerDiv>
);
